// extracted by mini-css-extract-plugin
module.exports = {"rotation":"ContattaRivenditoreTemplate_rotation__EzsG_"};